import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = [
    'list'
  ]

  connect() {
    if (this.hasListTarget) {
      this.listTarget.classList.add('animate-scroll');
      const listClone = this.listTarget.cloneNode(true);
      listClone.setAttribute('aria-hidden', 'true');
      this.listTarget.after(listClone);
    }
  }
}